
namespace RioERP.Users {
    export class CustomersColumns {
        static columnsKey = 'Users.Customers';
    }
}